<template>
<div>

  <!--
    MALINA
  -->

  <div
          v-if="page.indexOf('malina') != -1"
          class="sub-toolbar hidden-md-and-down"
  >

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Щорса, 5а к4</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79512237737"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79512237737"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79512237737"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (951) 223-77-37</a>

      </div>
    </div>

    <v-spacer></v-spacer>

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in malinaLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>
  </div>

  <!--
    MALINA MEDIUM
   -->

  <div
          v-if="page.indexOf('malina') != -1"
          class="sub-toolbar hidden-lg-and-up"
  >

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in malinaLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Щорса, 5а к4</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79512237737"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79512237737"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79512237737"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (951) 223-77-37</a>

      </div>
    </div>

  </div>



  <!--
    SADKO
  -->

  <div
          v-if="page.indexOf('sadko') != -1"
          class="sub-toolbar hidden-md-and-down"
  >

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Орджоникидзе, 28а</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79234640116"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79234640116"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79234640116"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (923) 464-01-16</a>

      </div>
    </div>

    <v-spacer></v-spacer>

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in sadkoLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>
  </div>

  <!--
    SADKO MEDIUM
   -->

  <div
          v-if="page.indexOf('sadko') != -1"
          class="sub-toolbar hidden-lg-and-up"
  >

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in sadkoLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Орджоникидзе, 28а</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79234640116"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79234640116"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79234640116"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (923) 464-01-16</a>

      </div>
    </div>

  </div>


  <!--
    ACROPOLIS
  -->

  <div
          v-if="page.indexOf('acropolis') != -1"
          class="sub-toolbar hidden-md-and-down"
  >

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Орджоникидзе, 13</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79617065757"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79617065757"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79617065757"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (961) 706-57-57</a>

      </div>
    </div>

    <v-spacer></v-spacer>

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in acropolisLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>
  </div>

  <!--
    ACROPOLIS MEDIUM
   -->

  <div
          v-if="page.indexOf('acropolis') != -1"
          class="sub-toolbar hidden-lg-and-up"
  >

    <div class="sub-toolbar-menu">
      <v-btn
              v-for="link in acropolisLinks"
              :key="link.title"
              :to="link.url"
              flat
              outline color="green"
      >
        {{ link.title }}
      </v-btn>
    </div>

    <div class="sub-toolbar-contacts">
      <div class="sub-toolbar-contacts-address">г. Новокузнецк, Орджоникидзе, 13</div>
      <div>

        <!--WHATSAPP-->
        <a href="https://wa.me/79617065757"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="green"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'whatsapp']"></font-awesome-icon>
          </v-btn>
        </a>

        <!--VIBER-->
        <a href="viber://chat?number=79617065757"
           target="_blank"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >
          <v-btn
                  fab
                  dark
                  small
                  color="#59267c"
          >
            <font-awesome-icon size="lg" :icon="['fab', 'viber']"></font-awesome-icon>
          </v-btn>
        </a>

        <a href="tel:+79617065757"
           onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
        >+7 (961) 706-57-57</a>

      </div>
    </div>

  </div>


</div>
</template>

<script>
export default {
  computed: {
    malinaLinks () {
      return this.$store.state.malinaLinks
    },
    sadkoLinks () {
      return this.$store.state.sadkoLinks
    },
    acropolisLinks () {
      return this.$store.state.acropolisLinks
    },
    page () {
      return this.$route.path
    }
  },
  methods: {

  }
}
</script>

<style scoped>
a,
a:hover,
a:visited,
a:active {
  color: black;
  text-decoration: none;
}

.sub-toolbar {
  display: flex;
  padding: 5px 0;
  border-top: 1px solid #c3c3c3;
  background-color: #FFFFFF;
}

.sub-toolbar-contacts {
  display: flex;
}

.sub-toolbar-contacts-address {
  padding: 13px 15px;
}

.sub-toolbar-menu {
  display: flex;
}

/* EXTRA SMALL */
@media (max-width: 600px) {

}

/* SMALL */
@media (max-width: 960px) {

}

/* MEDIUM */
@media (max-width: 1264px) {
  .sub-toolbar {
    display: block;
    padding: 5px 0;
    border-top: 1px solid #c3c3c3;
    background-color: #FFFFFF;
  }

  .sub-toolbar-contacts {
    display: block;
    text-align: center;
  }

  .sub-toolbar-menu {
    display: block;
    padding: 5px 0 0 0;
    text-align: center;
  }
}

/* LARGE */
@media (max-width: 1904px) {

}

/* X LARGE */
@media (min-width: 1904px) {

}

</style>



// WEBPACK FOOTER //
// src/components/SubToolbar.vue